import apiClient from './apiClient'

export interface Menu {
  id: number
  admin_id: number
  bot_session_id: number
  title: string
  content?: string
  type: 'static' | 'dynamic'
  requires_human: boolean
  parent_id?: number
  display_order: number
  response_template_id?: number
  use_template: boolean
  template_config?: any
  is_active: boolean
  created_at: string
  updated_at: string
  template?: {
    id: number
    name: string
    template_type: string
  }
  auto_conversation_tag_id?: number | null
  autoConversationTag?: {
    id: number
    name: string
    color: string
  }
  children?: Menu[]
}

export interface CreateMenuData {
  bot_session_id: number
  title: string
  content?: string
  type: 'static' | 'dynamic'
  requires_human?: boolean
  parent_id?: number
  display_order?: number
  response_template_id?: number
  use_template?: boolean
  template_config?: any
  /** null = não aplicar tag; número = contact_tags.id */
  auto_conversation_tag_id?: number | null
}

export interface UpdateMenuData extends Partial<CreateMenuData> {
  is_active?: boolean
}

export const menuService = {
  // Listar menus
  async getMenus(botSessionId?: number, page = 1, limit = 10) {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    })
    
    if (botSessionId) {
      params.append('bot_session_id', botSessionId.toString())
    }

    const response = await apiClient.get(`/menus?${params}`)
    return response.data
  },

  // Obter menu por ID
  async getMenu(id: number) {
    const response = await apiClient.get(`/menus/${id}`)
    return response.data
  },

  // Criar menu
  async createMenu(data: CreateMenuData) {
    const response = await apiClient.post('/menus', data)
    return response.data
  },

  // Atualizar menu
  async updateMenu(id: number, data: UpdateMenuData) {
    const response = await apiClient.put(`/menus/${id}`, data)
    return response.data
  },

  // Deletar menu
  async deleteMenu(id: number) {
    const response = await apiClient.delete(`/menus/${id}`)
    return response.data
  }
}